(function () {
	let youtubeApiPromise = null;
	const loadYouTubeApi = () => {
		if (window.YT && window.YT.Player) return Promise.resolve(window.YT);
		if (youtubeApiPromise) return youtubeApiPromise;

		youtubeApiPromise = new Promise((resolve) => {
			const previousCallback = window.onYouTubeIframeAPIReady;
			window.onYouTubeIframeAPIReady = () => {
				if (typeof previousCallback === "function") previousCallback();
				resolve(window.YT);
			};
			const tag = document.createElement("script");
			tag.src = "https://www.youtube.com/iframe_api";
			document.head.appendChild(tag);
		});
		return youtubeApiPromise;
	};

	const initYouTubePlayer = (mediaEl, section) => {
		if (!mediaEl || mediaEl.dataset.ytInitialized === "true") return;
		mediaEl.dataset.ytInitialized = "true";

		const iframe = mediaEl.querySelector(".js-youtube-frame");
		if (!iframe) return;

		const shouldLoop = mediaEl.dataset.videoLoop !== "false";
		const shouldAutoplay = mediaEl.dataset.videoAutoplay === "true";
		const startMuted = mediaEl.dataset.videoMuted === "true";

		loadYouTubeApi().then((YT) => {
			const player = new YT.Player(iframe, {
				events: {
					onReady: (event) => {
						mediaEl._ytPlayer = event.target;
						if (startMuted) {
							event.target.mute();
						} else {
							event.target.unMute();
						}
						if (shouldAutoplay) {
							event.target.playVideo();
							const playButton = section.querySelector(".js-play-video");
							if (playButton) playButton.classList.add("active");
						}
					},
					onStateChange: (event) => {
						if (event.data === YT.PlayerState.ENDED && shouldLoop) {
							event.target.seekTo(0);
							event.target.playVideo();
						}
						const playButton = section.querySelector(".js-play-video");
						if (!playButton) return;
						if (event.data === YT.PlayerState.PLAYING) {
							playButton.classList.add("active");
						} else if (
							event.data === YT.PlayerState.PAUSED ||
							event.data === YT.PlayerState.ENDED
						) {
							if (!shouldLoop || event.data === YT.PlayerState.PAUSED) {
								playButton.classList.remove("active");
							}
						}
					},
				},
			});
		});
	};

	const playVideo = (card) => {
		const video = card.querySelector(".banner__media video");
		if (video) {
			const button = card.querySelector(".js-play-video");

			if (video.parentElement.classList.contains("autoplay")) {
				video.autoplay = true;
				if (button) {
					button.classList.add("active");
				}
			}

			if (video.autoplay && video.paused) {
				video.play();
			}

			if (!video.autoplay && button) {
				button.classList.remove("active");
			}

			if (video.parentElement.dataset.videoLoop === "false") {
				video.addEventListener("ended", () => {
					button.classList.remove("active");
				});
			}
		}

		const ytMedia = card.querySelector(".banner__media--youtube");
		if (ytMedia && ytMedia._ytPlayer && ytMedia.dataset.videoAutoplay === "true") {
			try {
				ytMedia._ytPlayer.playVideo();
			} catch (e) {}
		}
	};

	const stopVideo = (card) => {
		const videoActive = card.querySelector(".banner__media video");
		if (videoActive) {
			videoActive.pause();
		}

		const ytMedia = card.querySelector(".banner__media--youtube");
		if (ytMedia && ytMedia._ytPlayer) {
			try {
				ytMedia._ytPlayer.pauseVideo();
			} catch (e) {}
		}
	};

	const controlsVideo = (section) => {
		const buttonsPlay = section.querySelector(".js-play-video");
		const buttonsSound = section.querySelector(".js-sound-video");
		const video = section.querySelector(".banner__media__video:not(.banner__media__youtube)");
		const ytMedia = section.querySelector(".banner__media--youtube");

		buttonsPlay?.addEventListener("click", (event) => onClickPlayPause(event));
		function onClickPlayPause(event) {
			const buttonPlay = event.currentTarget;
			if (buttonPlay.classList.contains("js-play-video")) {
				if (video) {
					if (video.paused) {
						video.play();
					} else {
						video.pause();
					}
					buttonPlay.classList.toggle("active");
				} else if (ytMedia && ytMedia._ytPlayer) {
					try {
						const state = ytMedia._ytPlayer.getPlayerState();
						if (state === 1) {
							ytMedia._ytPlayer.pauseVideo();
						} else {
							ytMedia._ytPlayer.playVideo();
						}
						buttonPlay.classList.toggle("active");
					} catch (e) {}
				}
			}
		}

		buttonsSound?.addEventListener("click", (event) => onClickSound(event));
		function onClickSound(event) {
			const buttonSound = event.currentTarget;
			if (buttonSound.classList.contains("js-sound-video")) {
				if (video) {
					if (video.muted) {
						setTimeout(() => {
							video.muted = false;
						}, 10);
					} else {
						setTimeout(() => {
							video.muted = true;
						}, 10);
					}
					buttonSound.classList.toggle("active");
				} else if (ytMedia && ytMedia._ytPlayer) {
					try {
						if (ytMedia._ytPlayer.isMuted()) {
							ytMedia._ytPlayer.unMute();
						} else {
							ytMedia._ytPlayer.mute();
						}
						buttonSound.classList.toggle("active");
					} catch (e) {}
				}
			}
		}
	};

	const initSection = (section) => {
		if (section && section.classList.contains("video-banner-section")) {
			const ytMedia = section.querySelector(".banner__media--youtube");
			if (ytMedia) {
				initYouTubePlayer(ytMedia, section);
			}

			const sectionObserver = new IntersectionObserver((entries) => {
				entries.forEach((entry) => {
					let mediaCards = entry.target.querySelectorAll(
						".video-banner__content"
					);

					if (entry.isIntersecting) {
						mediaCards.forEach((card) => playVideo(card));
					} else {
						mediaCards.forEach((card) => stopVideo(card));
					}
				});
			});

			sectionObserver.observe(section);
			controlsVideo(section);
		}

		const video_animation = section?.querySelector(
			".video-banner__scroll_animation"
		);

		if (video_animation) {
			gsap.registerPlugin(ScrollTrigger);

			let secondStarted = false;

			const video_content = section?.querySelector(
				".video-banner__sticky_content"
			);

			const video_controls = section?.querySelector(".video-banner__controls");

			const video_text = section?.querySelector(".video-banner__column");

			gsap.to(video_content, {
				height: "100vh",
				width: "100vw",
				scrollTrigger: {
					trigger: video_animation,
					start: "top top",
					end: "bottom bottom",
					scrub: true,
					onUpdate: (self) => {
						if (self.progress > 0.7 && !secondStarted) {
							secondStarted = true;
							gsap.to(video_text, {
								y: "0",
							});
						}

						if (self.progress < 0.7 && secondStarted) {
							secondStarted = false;
							gsap.to(video_text, {
								y: "100%",
							});
						}

						if (self.progress < 0.9) {
							video_content.classList.remove("remove_border_radius");
						}
					},
				},
				onComplete: () => video_content.classList.add("remove_border_radius"),
			});

			gsap.to(video_controls, {
				opacity: 1,
				scrollTrigger: {
					trigger: video_animation,
					start: "center center",
					end: "bottom bottom",
					scrub: true,
				},
			});
		}
	};

	initSection(document.currentScript.parentElement);

	document.addEventListener("shopify:section:load", function (section) {
		initSection(section.target);
	});
})();
